module.exports = __webpack_public_path__ + "img/9f614e9e-bf79-43a8-af62-34727647d709.a600fb2d.webp";